import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CBMError } from 'app/models';
import { AuthorizationService, OAuthService, UserService } from 'app/services';

@Component({
  selector: 'app-login-keycloak',
  templateUrl: './login-keycloak-callback.component.html',
  styleUrls: ['./login-keycloak-callback.component.scss']
})
export class LoginKeycloakCallbackComponent implements OnInit, AfterViewInit {
  public loading: boolean;
  public errorMessages: CBMError[];

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
    private readonly oauthService: OAuthService,
    private readonly authorizationService: AuthorizationService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.errorMessages = [];
  }

  ngAfterViewInit() {
    this.route.queryParamMap.subscribe(params => {
      const code = params.get('code');
      const sessionState = params.get('session_state');
      const state = params.get('state');

      try {
        this.oauthService.handleKeycloakCallback(code, sessionState, state).subscribe(
          () =>
            this.userService.getLoggedInUser().subscribe(
              user => {
                this.authorizationService.setAuthenticatedUserAndRoles(user, this.oauthService.getRoles());
                this.router.navigateByUrl('/contracts');
              },
              (errors: CBMError[]) => {
                this.loading = false;
                this.errorMessages = errors;
              }
            ),
          (errors: CBMError[]) => {
            // Something went wrong with retrieving the token
            this.loading = false;
            this.errorMessages = errors;
          }
        );
      } catch (e) {
        this.loading = false;
        this.errorMessages = [new CBMError('CL403', 'Handling Keycloak callback failed', e.message || '')];
        this.oauthService.logout();
        this.oauthService.initPkceFlow();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/login-keycloak-callback/login-keycloak-callback.component.ts